import { SxProps, Theme } from '@mui/material';

export const toggleButtonStyles: SxProps<Theme> = {
  px: '0.825rem',
  py: '0.125rem',
  fontSize: '0.75rem',
  fontWeight: 700,
  color: '#6C6C6C',
  border: 'none',
  '&.Mui-selected': {
    color: '#1B1C17',
    background: '#FFFFFF',
    borderRadius: '0.25rem',
  },
  '&.Mui-selected:hover': {
    backgroundColor: '#EFEFEF',
  },
};

export const toggleGroupStyles: SxProps<Theme> = {
  backgroundColor: '#E0E0E0',
  padding: '0.125rem',
  borderRadius: '0.25rem',
};
